import { ENV } from "./constants"
import { hash } from "./hash"

const initialChannels = {
  // ipc.on
  OPEN_INSTALL_PATH: "OPEN_INSTALL_PATH",
  OPEN_SYSTEM_PREFERENCES: "OPEN_SYSTEM_PREFERENCES",
  RESTART_APP: "RESTART_APP",
  GET_EQUIPMENT_INFO: "GET_EQUIPMENT_INFO",
  GET_BANNER_INFO: "GET_BANNER_INFO",
  IS_MULTI_SCREEN: "IS_MULTI_SCREEN",
  DISPLAY_MONITOR_CHANGED: "DISPLAY_MONITOR_CHANGED",
  DISPLAY_MONITOR_GET_COUNT: "DISPLAY_MONITOR_GET_COUNT",
  EXIT_APP: "EXIT_APP",
  GET_PLATFORM: "GET_PLATFORM",
  OPEN_PREFS_PANE: "OPEN_PREFS_PANE",
  GET_MEDIA_OS_PERMISSIONS: "GET_MEDIA_OS_PERMISSIONS",
  ASK_MEDIA_OS_PERMISSIONS: "ASK_MEDIA_OS_PERMISSIONS",
  OPEN_DEVICE_SYSTEM_PREFERENCES: "OPEN_DEVICE_SYSTEM_PREFERENCES",
  GET_CREDENTIALS: "GET_CREDENTIALS",
  BACK_TO_LOGIN_PAGE: "BACK_TO_LOGIN_PAGE",
  ARCHIVE_LOGS: "ARCHIVE_LOGS",
  REMOVE_OLD_ARCHIVED_LOGS: "REMOVE_OLD_ARCHIVED_LOGS",
  GET_FILE_STATE: "GET_FILE_STATE",
  SET_FILE_STATE: "SET_FILE_STATE",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  INTERFACE_LOADED: "INTERFACE_LOADED",
  INTERFACE_UNLOADED: "INTERFACE_UNLOADED",

  // logs
  LOG_INFO: "LOG_INFO",
  LOG_WARNING: "LOG_WARNING",
  LOG_ERROR: "LOG_ERROR",
  CONSOLE_INFO: "CONSOLE_INFO",
  CONSOLE_WARNING: "CONSOLE_WARNING",
  CONSOLE_ERROR: "CONSOLE_ERROR",

  // App
  SHOW_MAIN_WINDOW: "SHOW_MAIN_WINDOW",

  // Power management
  POWER_MANAGEMENT_SUSPEND: "POWER_MANAGEMENT_SUSPEND",
  POWER_MANAGEMENT_RESUME: "POWER_MANAGEMENT_RESUME",
  POWER_MANAGEMENT_LOCK_SCREEN: "POWER_MANAGEMENT_LOCK_SCREEN",
  POWER_MANAGEMENT_UNLOCK_SCREEN: "POWER_MANAGEMENT_UNLOCK_SCREEN",
  POWER_MANAGEMENT_APP_CRASH: "POWER_MANAGEMENT_APP_CRASH",
  POWER_MANAGEMENT_UPDATE_APP_CRASH: "POWER_MANAGEMENT_UPDATE_APP_CRASH",
  POWER_MANAGEMENT_EXAMS_CRASH: "POWER_MANAGEMENT_EXAMS_CRASH",
  POWER_MANAGEMENT_LOCK_EXAM: "POWER_MANAGEMENT_LOCK_EXAM",
  POWER_MANAGEMENT_STOP_LOCK_EXAM_INTERVAL: "POWER_MANAGEMENT_STOP_LOCK_EXAM_INTERVAL",
  POWER_MANAGEMENT_UNLOCK_EXAM: "POWER_MANAGEMENT_UNLOCK_EXAM",
  PREVENT_SLEEP_MODE_ACTIVATE: "PREVENT_SLEEP_MODE_ACTIVATE",
  PREVENT_SLEEP_MODE_DEACTIVATE: "PREVENT_SLEEP_MODE_DEACTIVATE",

  // Exam Timers
  GET_EXAM_TIMERS_STATE: "GET_EXAM_TIMERS_STATE",
  GET_ALL_EXAM_TIMERS_STATE: "GET_ALL_EXAM_TIMERS_STATE",
  SET_EXAM_TIMERS_STATE: "SET_EXAM_TIMERS_STATE",
  CLEAR_EXAM_TIMERS_STATE: "CLEAR_EXAM_TIMERS_STATE",

  // Exams uploads
  CREATE_EXAM_UPLOAD_DIRECTORY: "CREATE_EXAM_UPLOAD_DIRECTORY",
  REMOVE_EXAM_UPLOAD_DIRECTORY: "REMOVE_EXAM_UPLOAD_DIRECTORY",
  GET_UNACHIEVED_EXAM_UPLOAD: "GET_UNACHIEVED_EXAM_UPLOAD",
  GET_UNACHIEVED_EXAM_IDS: "GET_UNACHIEVED_EXAM_IDS",
  GET_UNACHIEVED_EXAM_ARCHIVE: "GET_UNACHIEVED_EXAM_ARCHIVE",
  ARCHIVE_EXAM_UPLOAD_DIRECTORY: "ARCHIVE_EXAM_UPLOAD_DIRECTORY",
  ADD_ONBOARDING_MEDIA_TO_UPLOAD_EXAM: "ADD_ONBOARDING_MEDIA_TO_UPLOAD_EXAM",

  // Updates
  CHECK_AND_INSTALL_UPDATE: "CHECK_AND_INSTALL_UPDATE",
  UPDATE_DOWNLOAD_PROGRESS: "UPDATE_DOWNLOAD_PROGRESS",

  GET_APP_INFOS: "GET_APP_INFOS",
  GET_ARCHIVE: "GET_ARCHIVE",

  // App
  QUIT_APP: "QUIT_APP",
  RELOAD_PAGE: "RELOAD_PAGE",
  MINIMIZE_APP: "MINIMIZE_APP",
  MAXIMIZE_APP: "MAXIMIZE_APP",
  TOGGLE_FULLSCREEN: "TOGGLE_FULLSCREEN",
  GET_CREDENTIALS_RESPOND: "GET_CREDENTIALS_RESPOND",
  OPEN_PREFS_PANE_RESPOND: "OPEN_PREFS_PANE_RESPOND",
  GET_MEDIA_OS_PERMISSIONS_RESPOND: "GET_MEDIA_OS_PERMISSIONS_RESPOND",
  UPLOAD_MEDIA_OBJECT_RESPOND: "UPLOAD_MEDIA_OBJECT_RESPOND",
  UPLOAD_MEDIA_OBJECT_AWS_RESPOND: "UPLOAD_MEDIA_OBJECT_AWS_RESPOND",
  EXPORT_STUDENT_PAPER_TO_ZIP_RESPOND: "EXPORT_STUDENT_PAPER_TO_ZIP_RESPOND",
  CREATE_ARCHIVE_BEFORE_UPLOAD_RESPOND: "CREATE_ARCHIVE_BEFORE_UPLOAD_RESPOND",
  CHECK_MEMORY_USAGE: "CHECK_MEMORY_USAGE",
  NOTIFY_NEW_EXAM: "NOTIFY_NEW_EXAM",
  NOTIFY_NEW_EXAM_ACTION: "NOTIFY_NEW_EXAM_ACTION",
  SECURITY_STOP_VALIDATE_ORIGIN: "SECURITY_STOP_VALIDATE_ORIGIN",
  SECURITY_STOP_VALIDATE_ORIGIN_RESPONSE: "SECURITY_STOP_VALIDATE_ORIGIN_RESPONSE",

  // Proctoring
  PROCTORING_HANDLE_AUDIO_RECORDING_CHUNKS: "PROCTORING_HANDLE_AUDIO_RECORDING_CHUNKS",
  PROCTORING_GET_AUDIO_RECORDING_FILE: "PROCTORING_GET_AUDIO_RECORDING_FILE",
  PROCTORING_HANDLE_SCREEN_RECORDING_CHUNKS: "PROCTORING_HANDLE_SCREEN_RECORDING_CHUNKS",
  PROCTORING_GET_SCREEN_RECORDING_FILE: "PROCTORING_GET_SCREEN_RECORDING_FILE",
  PROCTORING_SEAL_SCREEN_RECORDING_SEGMENT: "PROCTORING_SEAL_SCREEN_RECORDING_SEGMENT",
  PROCTORING_LIST_PENDING_SCREEN_SEGMENTS: "PROCTORING_LIST_PENDING_SCREEN_SEGMENTS",

  // Proctoring live - screen sharing
  DISPLAY_MEDIA_GET_SOURCES: "DISPLAY_MEDIA_GET_SOURCES",
  DISPLAY_MEDIA_SET_SOURCE: "DISPLAY_MEDIA_SET_SOURCE",

  /**
   * store
   */
  ELECTRON_STORE_CREATE: "ELECTRON_STORE_CREATE",
  ELECTRON_STORE_GET: "ELECTRON_STORE_GET",
  ELECTRON_STORE_SET: "ELECTRON_STORE_SET",
  ELECTRON_STORE_REMOVE: "ELECTRON_STORE_REMOVE",
  ELECTRON_STORE_CLEAR: "ELECTRON_STORE_CLEAR",

  /**
   *  persistStore
   */
  ELECTRON_PERSIST_STORE_GET: "ELECTRON_PERSIST_STORE_GET",
  ELECTRON_PERSIST_STORE_SET: "ELECTRON_PERSIST_STORE_SET",
  ELECTRON_PERSIST_STORE_REMOVE: "ELECTRON_PERSIST_STORE_REMOVE",

  /**
   *  files
   */
  GET_MAIN_LOGS_FILE: "GET_MAIN_LOGS_FILE",
  READ_FILE_SYNC: "READ_FILE_SYNC",
  GET_OPTION_FROM_FILE: "GET_OPTION_FROM_FILE",
  REMOVE_HEADER_MIME_TYPE_FROM_BASE_64_MEDIA_DATA:
    "REMOVE_HEADER_MIME_TYPE_FROM_BASE_64_MEDIA_DATA",
  GET_ZIPPED_PROCTOR_FILES: "GET_ZIPPED_PROCTOR_FILES",
  REMOVE_FILE: "REMOVE_FILE",
  READ_EXAM_FILE: "READ_EXAM_FILE",
  WRITE_EXAM_FILE: "WRITE_EXAM_FILE",
  FILE_EXIST: "FILE_EXIST",
  REMOVE_ALL_EXAM_FILES: "REMOVE_ALL_EXAM_FILES",
  REMOVE_EMPTY_EXAM_DIRECTORIES: "REMOVE_EMPTY_EXAM_DIRECTORIES",
  GET_AVAILABLE_DISK_SPACE: "GET_AVAILABLE_DISK_SPACE",

  // MEDIAS
  REMOVE_MEDIA_DIRECTORY: "REMOVE_MEDIA_DIRECTORY",

  // Security
  START_EXAM_SECURITY: "START_EXAM_SECURITY",
  STOP_EXAM_SECURITY: "STOP_EXAM_SECURITY",
  WINDOW_LOOSE_FOCUS: "WINDOW_LOOSE_FOCUS",
  SECURITY_ASK_FOR_PRIVILEGES: "SECURITY_ASK_FOR_PRIVILEGES",
  SECURITY_CLEAR_CLIPBOARD: "SECURITY_CLEAR_CLIPBOARD",
  SECURITY_HAS_PRIVILEGES: "SECURITY_HAS_PRIVILEGES",

  // SSO
  SSO_LOGIN: "SSO_LOGIN",

  // FileStore
  GET_FILE_STORE_STATE: "GET_FILE_STORE_STATE",
  GET_ALL_FILE_STORE_STATE: "GET_ALL_FILE_STORE_STATE",
  SET_FILE_STORE_STATE: "SET_FILE_STORE_STATE",
  CLEAR_FILE_STORE_STATE: "CLEAR_FILE_STORE_STATE",
}

export const channels = Object.entries(initialChannels).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: ENV === "production" ? hash(value) : value }),
  {} as Record<keyof typeof initialChannels, string>,
)
